import SharedByItem from "./shared-by-item";

export default SharedByItem;
